<template>
  <!-- KST/UTC 시간대 전환 토글 (ux-patterns.md §6) -->
  <a-button size="small" @click="$emit('toggle')" style="font-size: 12px;">
    {{ currentTz === 'kst' ? 'KST' : 'UTC' }}
    <swap-outlined />
  </a-button>
</template>

<script>
// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-COMMON-004
import { SwapOutlined } from '@ant-design/icons-vue';

export default {
  name: 'TimezoneToggle',
  components: { SwapOutlined },
  props: {
    currentTz: { type: String, default: 'kst' },
  },
  emits: ['toggle'],
};
</script>
